import { render, staticRenderFns } from "./BlocoInformacaoSkeleton.vue?vue&type=template&id=330c5834&scoped=true&lang=pug"
import script from "./BlocoInformacaoSkeleton.vue?vue&type=script&lang=js"
export * from "./BlocoInformacaoSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BlocoInformacaoSkeleton.vue?vue&type=style&index=0&id=330c5834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c5834",
  null
  
)

export default component.exports